import { useState, createContext, useContext, useMemo, ReactNode } from 'react';
import { useParams } from 'react-router-dom';
import { useMount, useSessionStorage } from 'react-use';
import { SearchAppUsersResponse } from './api';
import { AppUser } from './types';

type ContextValue =
  | (AppUser & {
      setSelected: (user: AppUser) => void;
    })
  | {
      setSelected: (user: AppUser) => void;
    };

const Context = createContext<ContextValue>({
  setSelected: () => undefined,
});

export const useSetSelected = () => {
  const { setSelected } = useContext(Context);
  return setSelected;
};

export const useSelected: () => AppUser | null = () => {
  const context = useContext(Context);

  const appUser = useMemo(() => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { setSelected, ...rest } = context;
    return rest;
  }, [context]);

  return Object.keys(appUser).length > 0 ? (appUser as AppUser) : null;
};

export const SelectedAppUserProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [appUser, setAppUser] = useState<AppUser>();
  const params = useParams();
  const [value] = useSessionStorage<SearchAppUsersResponse | null>(
    'qbAppUserSearchResult'
  );

  useMount(() => {
    if (params['*']) {
      const user = value?.profiles.filter((u) => u.userId === params['*'])[0];
      setAppUser(user);
    }
  });

  const context = useMemo(() => {
    return { ...appUser, setSelected: setAppUser };
  }, [appUser]);

  return <Context.Provider value={context}>{children}</Context.Provider>;
};
